export type SendBookingInvitationsTarget = { kind: 'clients'; clientIds: string[] } | { kind: 'results'; resultIds: string[] } | { kind: 'matched' }

export interface SendBookingInvitationsLocationState {
  target: SendBookingInvitationsTarget
  count: number
}

export const sendBookingInvitationsPath = (executionId: string): string => `/cross-client/executions/${executionId}/schedule-meeting`

const isNonEmptyIdList = (ids: unknown): ids is string[] => Array.isArray(ids) && ids.length > 0 && ids.every((id) => typeof id === 'string')

const readTarget = (target: unknown): SendBookingInvitationsTarget | null => {
  const candidate = target as { kind?: unknown; clientIds?: unknown; resultIds?: unknown } | null | undefined
  if (candidate?.kind === 'clients' && isNonEmptyIdList(candidate.clientIds)) {
    return { kind: 'clients', clientIds: candidate.clientIds }
  }
  if (candidate?.kind === 'results' && isNonEmptyIdList(candidate.resultIds)) {
    return { kind: 'results', resultIds: candidate.resultIds }
  }
  if (candidate?.kind === 'matched') {
    return { kind: 'matched' }
  }
  return null
}

export const readSendBookingInvitationsState = (state: unknown): SendBookingInvitationsLocationState | null => {
  const candidate = state as Partial<SendBookingInvitationsLocationState> | null
  const target = readTarget(candidate?.target)
  const count = candidate?.count
  return target && typeof count === 'number' && count > 0 ? { target, count } : null
}
